'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window */


/**
 * This component does not render any content but adds paging via key
 * commands.
 *
 * If a slide has fragments this component will split the slide into
 * different steps.
 * @public
 */
var Paging = function (_Component) {
  _inherits(Paging, _Component);

  _createClass(Paging, null, [{
    key: 'propTypes',

    /**
     * @private
     */
    get: function get() {
      return {
        trigger: _propTypes2.default.oneOf(['keyup', 'keydown']),
        toNextFragment: _propTypes2.default.func,
        toPrevFragment: _propTypes2.default.func,
        toNextSlide: _propTypes2.default.func,
        toPrevSlide: _propTypes2.default.func,
        slideCount: _propTypes2.default.number,
        slideIndex: _propTypes2.default.number,
        fragmentCount: _propTypes2.default.number,
        fragmentIndex: _propTypes2.default.number
      };
    }

    /**
     * @private
     */

  }, {
    key: 'defaultProps',
    get: function get() {
      return {
        trigger: 'keyup',
        toNextFragment: function toNextFragment() {
          return null;
        },
        toPrevFragment: function toPrevFragment() {
          return null;
        },
        toNextSlide: function toNextSlide() {
          return null;
        },
        toPrevSlide: function toPrevSlide() {
          return null;
        },
        slideCount: 0,
        slideIndex: 0,
        fragmentCount: 0,
        fragmentIndex: 0
      };
    }

    /**
     * @public
     * @param {Object} props
     *   The properties
     * @param {String} [props.trigger='keyup']
     *   The event that triggers paging
     * @param {number} props.slideCount
     *   (Injected via Dekk)
     * @param {number} props.slideIndex
     *   (Injected via Dekk)
     * @param {number} props.fragmentCount
     *   (Injected via Dekk)
     * @param {number} props.fragmentIndex
     *   (Injected via Dekk)
     * @param {number} props.fragmentOrder
     *   (Injected via Dekk)
     * @param {function} props.toFragment
     *   (Injected via Dekk)
     * @param {function} props.toSlide
     *   (Injected via Dekk)
     * @param {function} props.toNextFragment
     *   (Injected via Dekk)
     * @param {function} props.toPrevFragment
     *   (Injected via Dekk)
     * @param {function} props.toNextSlide
     *   (Injected via Dekk)
     * @param {function} props.toPrevSlide
     *   (Injected via Dekk)
     * @example
     * import Deck, {Plugins} from '@dekk/deck'
     * import Paging from '@dekk/paging'
     *
     * export default (
     *   <Deck>
     *     <Plugins>
     *       <Paging/>
     *     </Plugins>
     *   </Deck>
     * )
     */

  }]);

  function Paging(props) {
    _classCallCheck(this, Paging);

    var _this = _possibleConstructorReturn(this, (Paging.__proto__ || Object.getPrototypeOf(Paging)).call(this, props));

    _this.goTo = _this.goTo.bind(_this);
    return _this;
  }

  /**
   * Listen to events before we mount the component
   * @private
   */


  _createClass(Paging, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener(this.props.trigger, this.goTo);
    }

    /**
     * Unlisten to events before we unmount the component
     * @private
     */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener(this.props.trigger, this.goTo);
    }

    /**
     * Method to navigate to fragments or slides.
     * Uses left and right arrow buttons to navigate
     * @private
     * @param  {Object} e
     *   The event
     * @param {number} e.which
     *   The keyCode that has been triggered by the event
     */

  }, {
    key: 'goTo',
    value: function goTo(_ref) {
      var which = _ref.which;
      var _props = this.props,
          slideCount = _props.slideCount,
          slideIndex = _props.slideIndex,
          fragmentIndex = _props.fragmentIndex,
          fragmentCount = _props.fragmentCount,
          toNextSlide = _props.toNextSlide,
          toPrevSlide = _props.toPrevSlide,
          toNextFragment = _props.toNextFragment,
          toPrevFragment = _props.toPrevFragment;


      var hasFragments = Boolean(fragmentCount);

      var lastFragment = Math.max(0, fragmentCount - 1);

      var previousFragment = Math.max(0, fragmentIndex - 1);
      var nextFragment = Math.min(lastFragment, fragmentIndex + 1);

      var lastSlide = Math.max(0, slideCount - 1);
      var previousSlide = Math.max(0, slideIndex - 1);
      var nextSlide = Math.min(lastSlide, slideIndex + 1);

      var handleNext = function handleNext() {
        if (hasFragments && nextFragment > fragmentIndex) {
          toNextFragment();
        } else if (nextSlide !== slideIndex) {
          toNextSlide();
        }
      };

      var handlePrev = function handlePrev() {
        if (hasFragments && previousFragment < fragmentIndex) {
          toPrevFragment();
        } else if (previousSlide !== slideIndex) {
          toPrevSlide();
        }
      };

      // Switch between left and right arrow buttons
      switch (which) {
        case 39:
          handleNext();
          break;
        case 37:
          handlePrev();
          break;
        default:
          break;
      }
    }

    /**
     * @private
     */

  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Paging;
}(_react.Component);

exports.default = Paging;